module.exports = __webpack_public_path__ + "static/img/cont40_01.55f1b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_01.jpg
// module id = xTRs
// module chunks = 0